import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LOAD_STATES } from '../../../reducers/common';
import {
  chooseColumnReference,
  listColumnOptions,
  listDictionaryOptions,
  syncActions
} from '../../../actions/dictionary-values';
import history from '../../../history';
import { Box, Flex, Grid } from '@chakra-ui/react';
import { Form } from '../form';
import { BreadCrumbsComponent } from '../../../components/breadcrumbs/breadcrumbsComponent';
import { showFeedback } from '../../../actions/ui';
import LoaderOverlay from '../../../components/loader-overlay/loader-overlay';
import { styles } from '../dictionary-styles';
import { Action } from 'redux';

const CrossMapEdit = (props: any) => {
  const dispatch = useDispatch();

  const { loadState, activeColumn, activeColumnMetadataObj } = useSelector(
    (state: CMx.ApplicationState) => {
      return state.dictionaryValues.columnMetadataEditor;
    }
  );

  const tenantId = useSelector((state: CMx.ApplicationState) => {
    return state.dictionaryRequest.dictionaryMetadata.tenantId;
  });

  const { columnMetadataForm, loadState: tenantLoad } = useSelector(
    (state: CMx.ApplicationState) => {
      return state.dictionaryRequest;
    }
  );

  const tenantOptions = useSelector((state: CMx.ApplicationState) => {
    // Getting tenant list from metadata form
    return state.dictionaryRequest?.columnMetadataForm?.fields?.[1]?.options ?? [];
  });

  const isTenantListLoading = tenantLoad === LOAD_STATES.started;

  useEffect(() => {
    if (activeColumn.keyColumnIndicator) {
      dispatch(
        showFeedback({
          message: `Crossmapping the key column ${activeColumn.name} is not advised. Key columns should be unique to a dictionary.`,
          meta: { level: 'WARNING' },
          dismissable: true,
          className: 'feedback-error',
          id: Date.now()
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePropChange = (prop: string, value: any) => {
    if (prop === 'referenceTenant') {
      let organizationName: string = '';
      tenantOptions?.forEach((tenant: any) => {
        if (tenant.key === value) {
          organizationName = tenant.tenantName;
        }
      });
      const payload = { tenantId: value, orgName: organizationName };
      dispatch((listDictionaryOptions(payload) as any) as Action);
    }
    if (prop === 'referenceDictionary') {
      const payload = {
        tenantId: tenantId,
        dictionaryName: value
      };
      dispatch((listColumnOptions(payload) as any) as Action);
    }
    if (prop === 'referenceColumn') {
      dispatch(chooseColumnReference(value));
    }
  };

  const handleSaveCrossmap = (submitEvent: CMx.ColumnMetadataDataItem) => {
    const payload = {
      mappingInfo: submitEvent,
      columnInfo: activeColumn
    };
    dispatch(syncActions.saveColumnMapping(payload));
    props.history.goBack();
  };

  const handleAction = (event: CustomEvent) => {
    const { detail } = event;
    if (detail.eventType === 'cancel') {
      const pathParts = window.location.pathname.split('/');
      pathParts.pop();
      pathParts.pop();
      history.push(`${pathParts.join('/')}`);
    }
  };

  const subformEnabler = () => {
    return loadState !== LOAD_STATES.started;
  };

  const classes = styles();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>

      <Grid sx={isTenantListLoading ? classes.breadCrumbGrid : {}}>
        <Flex>
          <BreadCrumbsComponent />
        </Flex>
      </Grid>
      {isTenantListLoading ? (
        <Grid sx={classes.loaderWrapper}>
          <LoaderOverlay />
        </Grid>
      ) : (
        <Box overflowY='auto'>
          <Form
            formDefinition={columnMetadataForm}
            dataItem={activeColumnMetadataObj}
            onPropChange={handlePropChange}
            onSave={handleSaveCrossmap}
            enable={subformEnabler}
            onAction={handleAction}
            title={`${activeColumn?.name} Crossmaps`}
            errors={{
              status: '',
              message: null,
              errors: [],
              fieldErrors: {}
            }}
            inline={false}
          /></Box>
      )}
    </div>
  );
};

export { CrossMapEdit };
